import { RemoteActivitiesSummaryByTask } from 'data/usecases';
import { GetActivitiesSummaryByTaskUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivitiesSummaryByTask } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeActivitiesSummaryByTask =
  (): GetActivitiesSummaryByTaskUseCaseInterface =>
    new RemoteActivitiesSummaryByTask(
      makeApiUrlActivitiesSummaryByTask(),
      makeAxiosHttpClient(),
    );
